module.exports = __webpack_public_path__ + "static/img/3_1_3_4.67ee2bd6.jpg";